import { ConsultingServicesAgreement } from "../projects";  
import { IConverter, TSnapshot } from "./generics";

export const consultingServicesAgreementConverter: IConverter<ConsultingServicesAgreement> =
  {
    toFirestore(csa: ConsultingServicesAgreement) {
      return csa;
    },
    fromFirestore(snapshot: TSnapshot): ConsultingServicesAgreement {
      const data = snapshot.data();
      return {
        id: snapshot.id,
        clientId: data?.clientId,
        status: data?.status,
        projectId: data?.projectId,
        name: data?.name,
        effectiveDate: data?.effectiveDate,
        csaType: data?.csaType,
        billableRates: data?.billableRates,
        monthlyBudget: data?.monthlyBudget,
        fixedPriceBudget: data?.fixedPriceBudget,
        fileUrl: data?.fileUrl,
      };
    },
  };
